import { createUseStore } from '../createUseStore';
import { AuthSessionContext } from './AuthSessionContext';

export const useSessionStore = createUseStore(
  AuthSessionContext,
  'AuthSessionContext',
);
